import { eventWrapper } from '@testing-library/user-event/dist/utils';
import '../App.css';

import React, {useState, useEffect, use} from 'react';

import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

import ApplicationCard from '../components/ApplicationCard.jsx';


function Newbies() {
    const [step, setStep] = useState(1);
    const [percent, setPercent] = useState(0);
    const [level, setLevel] = useState(1);
    const [company, setCompany] = useState(1); // 1=both ; 2=EPD ; 3=SRT
    const [rank, setRank] = useState(10); 
    const [rankString, setRankString] = useState("O1"); // E1-E9 ; O1-O10
    const [professionality, setProfessionality] = useState(1);
    const [months, setMonths] = useState("18"); 

    let totalSteps = 8; 

    const LinkEPDAppTracker = () => {
        window.open("https://docs.google.com/spreadsheets/d/1yUtJJOUymcOskz19bFOxkyoBi5N8ksCjj_JGxQFuAoc/edit?gid=776690654#gid=776690654");
    }

    const LinkSRTAppTracker = () => {
        window.open("https://docs.google.com/spreadsheets/d/1gTTvao1dR9xYelafkhc8FCfSQMRMdebrSJZHbvjMJ-c/edit?gid=776690654#gid=776690654");
    }

    const convertRank = (rank) => {
        if (rank >= 10) {
            return "O" + (rank - 9);
        } else {
            return "E" + (rank);
        }
    }

    useEffect(() => {
        setRankString(convertRank(rank));
    }, [rank]); // Update rankString whenever rank changes

    useEffect(() => {
       
        if (months == 0) {
            setMonths("0");
        } else if (months == "36") {
            setMonths("36+");
        } else {
            setMonths(months);
        }
        
    }, [months]); 

    useEffect(() => {
        
        setPercent((step / totalSteps) * 100);
        
    }, [step]); 


  return (
    <>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            <hr className="my-5" />
            <h3>Zanances USAR</h3>
            <h1>503rd Battalion</h1>
            <hr className="my-3" />
        </div>
        
        
            
                {step === 1 && (
                <div className="card" style={{width: "35rem", margin: "auto"}}>
                <div className="card-body">
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                        <Link to="/"><button className="btn btn-outline-primary" type="button"  >I just want to look around</button></Link>      
                        <br />
                        <button className="btn btn-outline-primary" type="button"  onClick={() => setStep(2)}>I want to join 503rd</button>
                    </div>
                </div> 
                </div>

                )}

                {step === 2 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>Have you ever been in OCS?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <button className="btn btn-outline-danger" style={{margin: "1%"}} type="button"  onClick={() => (setLevel(1), setStep(3), setProfessionality(professionality + 10))}>No</button>
                                        <button className="btn btn-outline-success" style={{margin: "1%"}} type="button"  onClick={() => (setLevel(3), setStep(3), setProfessionality(professionality + 20))}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 3 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>Have you ever been Company Staff or higher?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <button className="btn btn-outline-danger" style={{margin: "1%"}} type="button"  onClick={() => (setStep(4))}>No</button>
                                        <button className="btn btn-outline-success" style={{margin: "1%"}} type="button"  onClick={() => (setStep(4), setProfessionality(professionality + 30))}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 4 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>Have you ever been blacklisted from any unit in USAR?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <button className="btn btn-outline-danger" style={{margin: "1%"}} type="button"  onClick={() => (setStep(5))}>No</button>
                                        <button className="btn btn-outline-success" style={{margin: "1%"}} type="button"  onClick={() => (setStep(5), setProfessionality(professionality - 30))}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 5 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>Which company are you interested in?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <button className="btn btn-outline-primary" style={{margin: "1%", width: "20%"}} type="button"  onClick={() => (setStep(6), setCompany(2))}>EPD</button>
                                        <button className="btn btn-outline-primary" style={{margin: "1%", width: "20%"}} type="button"  onClick={() => (setStep(6), setCompany(1))}>Both</button>
                                        <button className="btn btn-outline-primary" style={{margin: "1%", width: "20%"}} type="button"  onClick={() => (setStep(6), setCompany(3))}>SRT</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 6 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>What is your current rank?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <label for="customRange2" className="form-label">Rank</label>
                                        <input type="range" className="form-range" min="1" max="19" id="customRange2" onChange={(e) => (setRank(e.target.value),setRankString(convertRank(rank)))} /> 
                                    </div>
                                    <p>{rankString}</p>
                                    
                                </div>
                                <button className="btn btn-outline-primary" style={{margin: "1%", width: "20%"}} type="button"  onClick={() => (setStep(7), setProfessionality(professionality + 5*rank))}>Continue</button>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 7 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>How many months have you been in USAR?</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <div className="col">
                                        <label for="customRange2" className="form-label">Months</label>
                                        <input type="range" className="form-range" min="0" max="36" id="customRange2" onChange={(e) => (setMonths(e.target.value.toString()))} /> 
                                    </div>
                                    <p>{months}</p>
                                    
                                </div>
                                <button className="btn btn-outline-primary" style={{margin: "1%", width: "20%"}} type="button"  onClick={() => (setStep(8), setProfessionality(professionality + 5*months.replace(/\D/g, '')))}>Continue</button>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

                {step === 8 && (
                    <div className="card" style={{width: "35rem", margin: "auto"}}>
                    <div className="card-body">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <h5>You have a professionality score of: {professionality}</h5>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                            <div className="container text-center">
                                <div className="row align-items-start">
                                    <p>The professionality score is a number that allows us <br /> to give you a recommendation on what positions<br /> in 503rd are just perfectly made for you.</p>
                                    
                                </div>
                                <button className="btn btn-outline-primary" style={{margin: "1%", width: "60%"}} type="button"  onClick={() => (setStep(9))}>What position should I apply for?</button>
                            </div>
                        </div>
                        
                    </div> 
                    </div>
                )}

            
       
        
        <br />
        {step >= 2 && step <= totalSteps && (
            <>
                <div className="progress" role="progressbar" aria-label="Progress" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100" style={{width: "35rem", margin: "auto"}}>
                    <div className="progress-bar" style={{width: percent + '%'}}></div>
                </div>
            </>
        )}

        {step > totalSteps && (
            <>
               <div className="container text-center">
                    <div className="row align-items-start">
                    {(company === 1 || company === 3) && (
                        <div className="col"> 
                            <div className="d-grid gap-2">
                            <h3>Special Reaction Team</h3>
                            <button type="button" className="btn btn-outline-primary" onClick={LinkSRTAppTracker}>Application Tracker</button><br /> 
                            <div className="row align-items-start" style={{marginLeft: "1.6%"}}>
                            {(professionality >= 150) && (
                               <ApplicationCard type={"SP"} /> 
                            )}

                            {(professionality >= 100) && (
                                <>
                                    <ApplicationCard type={"LO"} /> 
                                    <ApplicationCard type={"P"} />
                                </>  
                            )}
                            
                            {(professionality >= 80) && (
                                <>
                                    <ApplicationCard type={"SRTOO"} />
                                </>  
                            )}

                            {(professionality >= 50) && (
                                <>
                                    <ApplicationCard type={"OS"} />
                                </>  
                            )}
                            {(professionality >= 0) && (
                                <>
                                    <ApplicationCard type={"OG"} />
                                </>  
                            )}
                            
                            </div>
                            </div>
                        </div>
                    )}
                        
                        
                    {(company === 1 || company === 2) && (
                        <div className="col"> 
                        
                        <div className="d-grid gap-2">
                            <h3>Executive Protection Detail</h3>
                            <button type="button" className="btn btn-outline-primary" onClick={LinkEPDAppTracker}>Application Tracker</button><br />
                            <div className="row align-items-start" style={{marginLeft: "1.6%"}}>
                            
                            {(professionality >= 100) && (
                                <>
                                    <ApplicationCard type={"DO"} />
                                </>  
                            )}
                            
                            {(professionality >= 80) && (
                                <>
                                    <ApplicationCard type={"EPDOO"} />
                                </>  
                            )}

                            {(professionality >= 50) && (
                                <>
                                    <ApplicationCard type={"DS"} />
                                </>  
                            )}
                            {(professionality >= 0) && (
                                <>
                                    <ApplicationCard type={"PO"} />
                                </>  
                            )}
                            
                            
                            </div>
                        </div>
                        
                        </div>
                    )}
                    <hr className="my-4" style={{visibility: "hidden"}} />
                    <div className="col" >
                        <Link to="/"><button type="button" className="btn btn-outline-primary"style={{marginRight: "0.5%"}} >Homepage</button></Link>
                        <button type="button" className="btn btn-outline-primary" style={{marginLeft: "0.5%"}} onClick={(e) => (setStep(1))}>Try again</button><br /><br />
                    </div>
                    
                    <i><p className='text-body-secondary' style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>All applications can be viewed on the homepage.</p></i>
                    </div>
                        
                </div> 
                
            </>
            
        )}
        
        

    </>
);
}


export default Newbies;